import { FiDownload, FiExternalLink } from "react-icons/fi";
import { links, profile } from "../data/profile";
import "../styles/Resume.css";

const Resume = () => (
  <div className="page">
    <header className="page-head animate-in">
      <h1 className="page-head__title">
        <span className="gradient-text">Resume</span>
      </h1>
      <p className="lede">
        {profile.yearsExperience} years across observability, SRE, and cloud
        platform engineering. Open the full PDF, or verify credentials on
        CertDirectory.
      </p>
      <div className="resume__actions">
        <a
          className="btn btn--primary"
          href={profile.resumePdf}
          target="_blank"
          rel="noopener noreferrer"
        >
          Open PDF <FiDownload />
        </a>
        <a
          className="btn"
          href={links.certDirectory}
          target="_blank"
          rel="noopener noreferrer"
        >
          CertDirectory <FiExternalLink />
        </a>
      </div>
    </header>

    <section className="section">
      <a
        className="resume-preview animate-in stagger-2"
        href={profile.resumePdf}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Open resume PDF"
      >
        <img src={profile.resumeImage} alt="Resume preview" />
        <span className="resume-preview__hint">Open PDF ↗</span>
      </a>
    </section>
  </div>
);

export default Resume;
